module.exports = __webpack_public_path__ + "assets/img/zyrw01.1488bfcf.png";